import { publicEnv } from "../app/env";
import type { PerformanceTier } from "../types/traffic";
import { MockTrafficRealtimeProvider } from "./realtime/MockTrafficRealtimeProvider";
import { OfflineTrafficRealtimeProvider } from "./realtime/OfflineTrafficRealtimeProvider";
import { SupabaseTrafficRealtimeProvider } from "./realtime/SupabaseTrafficRealtimeProvider";
import type { TrafficRealtimeProvider } from "./realtime/TrafficRealtimeProvider";
import { MockTrafficApi } from "./traffic-api/MockTrafficApi";
import { NetlifyTrafficApi } from "./traffic-api/NetlifyTrafficApi";
import { OfflineTrafficApi } from "./traffic-api/OfflineTrafficApi";
import type { TrafficApi } from "./traffic-api/TrafficApi";

export type TrafficServices = {
  api: TrafficApi;
  realtime: TrafficRealtimeProvider;
  transportMode: "mock" | "supabase" | "offline";
  setSimulatedDriverCount(driverCount: number): void;
  setPerformanceTier(tier: PerformanceTier): void;
};

export function createTrafficServices(
  performanceTier: PerformanceTier,
  initialDriverCount: number,
): TrafficServices {
  if (
    publicEnv.VITE_REALTIME_MODE === "mock" &&
    publicEnv.VITE_APP_ENV !== "production"
  ) {
    const api = new MockTrafficApi();
    const realtime = new MockTrafficRealtimeProvider(
      performanceTier,
      initialDriverCount,
    );
    return {
      api,
      realtime,
      transportMode: "mock",
      setSimulatedDriverCount(driverCount) {
        api.setDriverCount(driverCount);
        realtime.setDriverCount(driverCount);
      },
      setPerformanceTier(tier) {
        realtime.setPerformanceTier(tier);
      },
    };
  }

  if (
    publicEnv.VITE_REALTIME_MODE === "supabase" &&
    publicEnv.VITE_SUPABASE_URL &&
    publicEnv.VITE_SUPABASE_ANON_KEY
  ) {
    return {
      api: new NetlifyTrafficApi(),
      realtime: new SupabaseTrafficRealtimeProvider(
        publicEnv.VITE_SUPABASE_URL,
        publicEnv.VITE_SUPABASE_ANON_KEY,
      ),
      transportMode: "supabase",
      setSimulatedDriverCount() {
        return;
      },
      setPerformanceTier() {
        return;
      },
    };
  }

  return {
    api: new OfflineTrafficApi(),
    realtime: new OfflineTrafficRealtimeProvider(),
    transportMode: "offline",
    setSimulatedDriverCount() {
      return;
    },
    setPerformanceTier() {
      return;
    },
  };
}
